import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'replace'
})
export class ReplacePipe implements PipeTransform {

  transform(value: string, 
  	replaceWhat: string, replaceWith: string): any {
    //return value.replace(replaceWhat, replaceWith);
    if(value==null) return '';
    return value.toString().split(replaceWhat).join(replaceWith);
  }

}
